import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Job Tracking")
  ])
], -1)
const _hoisted_3 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-9" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tranche", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Partner", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "col-md-2" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Institute", -1)
const _hoisted_16 = { class: "col-md-2" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Course", -1)
const _hoisted_18 = { class: "col-md-2" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Batch", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = { class: "col-md-2 mt-8" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_23 = { key: 0 }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("h4", { class: "mt-5" }, "Job Tracking List", -1)
const _hoisted_25 = { class: "row w-100 mb-2" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" })
], -1)
const _hoisted_27 = {
  class: "col-md-6 text-end",
  "data-v-54b12dc8": ""
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-excel fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-pdf fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa fa-print fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = { class: "table-responsive mt-3" }
const _hoisted_35 = {
  class: "table table-borderless gy-4",
  style: {"width":"2200px"}
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("tr", { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-dark" }, [
  /*#__PURE__*/_createElementVNode("th", {
    style: {"border":"1px solid  !important","text-align":"center"},
    rowspan: "3"
  }, " SL "),
  /*#__PURE__*/_createElementVNode("th", {
    style: {"text-align":"center","border":"1px solid  !important"},
    rowspan: "3"
  }, " Registration Number "),
  /*#__PURE__*/_createElementVNode("th", {
    style: {"border":"1px solid  !important","text-align":"center"},
    rowspan: "3"
  }, " Name "),
  /*#__PURE__*/_createElementVNode("th", {
    style: {"border":"1px solid  !important","text-align":"center"},
    rowspan: "3"
  }, " Phone Number "),
  /*#__PURE__*/_createElementVNode("th", {
    style: {"border":"1px solid  !important","text-align":"center"},
    colspan: "15"
  }, " Job Tracking Data "),
  /*#__PURE__*/_createElementVNode("th", {
    style: {"border":"1px solid  !important","text-align":"center"},
    rowspan: "3"
  }, " Comments ")
], -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("tr", { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-dark" }, [
  /*#__PURE__*/_createElementVNode("th", {
    style: {"text-align":"center","border":"1px solid  !important"},
    colspan: "5"
  }, " Job Status at Course Completion Date "),
  /*#__PURE__*/_createElementVNode("th", {
    style: {"text-align":"center","border":"1px solid  !important"},
    colspan: "5"
  }, " Job Status after 3 months "),
  /*#__PURE__*/_createElementVNode("th", {
    style: {"text-align":"center","border":"1px solid  !important"},
    colspan: "5"
  }, " Job Status after 6 months ")
], -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("tr", { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-dark" }, [
  /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","border":"1px solid  !important"} }, " Designation "),
  /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","border":"1px solid  !important"} }, " From "),
  /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","border":"1px solid  !important"} }, " To "),
  /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","border":"1px solid  !important"} }, " Gross Salary "),
  /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","border":"1px solid  !important"} }, " Company "),
  /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","border":"1px solid  !important"} }, " Designation "),
  /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","border":"1px solid  !important"} }, " From "),
  /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","border":"1px solid  !important"} }, " To "),
  /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","border":"1px solid  !important"} }, " Gross Salary "),
  /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","border":"1px solid  !important"} }, " Company "),
  /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","border":"1px solid  !important"} }, " Designation "),
  /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","border":"1px solid  !important"} }, " From "),
  /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","border":"1px solid  !important"} }, " To "),
  /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","border":"1px solid  !important"} }, " Gross Salary "),
  /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","border":"1px solid  !important"} }, " Company ")
], -1)
const _hoisted_39 = { style: {"border":"1px solid  !important","text-align":"center"} }
const _hoisted_40 = { style: {"border":"1px solid  !important","text-align":"center"} }
const _hoisted_41 = { style: {"border":"1px solid  !important","text-align":"center"} }
const _hoisted_42 = { style: {"border":"1px solid  !important","text-align":"center"} }
const _hoisted_43 = { style: {"border":"1px solid  !important","text-align":"center"} }
const _hoisted_44 = { style: {"border":"1px solid  !important","text-align":"center"} }
const _hoisted_45 = { style: {"border":"1px solid  !important","text-align":"center"} }
const _hoisted_46 = { style: {"border":"1px solid  !important","text-align":"center"} }
const _hoisted_47 = { style: {"border":"1px solid  !important","text-align":"center"} }
const _hoisted_48 = { style: {"border":"1px solid  !important","text-align":"center"} }
const _hoisted_49 = { style: {"border":"1px solid  !important","text-align":"center"} }
const _hoisted_50 = { style: {"border":"1px solid  !important","text-align":"center"} }
const _hoisted_51 = { style: {"border":"1px solid  !important","text-align":"center"} }
const _hoisted_52 = { style: {"border":"1px solid  !important","text-align":"center"} }
const _hoisted_53 = { style: {"border":"1px solid  !important","text-align":"center"} }
const _hoisted_54 = { style: {"border":"1px solid  !important","text-align":"center"} }
const _hoisted_55 = { style: {"border":"1px solid  !important","text-align":"center"} }
const _hoisted_56 = { style: {"border":"1px solid  !important","text-align":"center"} }
const _hoisted_57 = { style: {"border":"1px solid  !important","text-align":"center"} }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("td", { style: {"border":"1px solid  !important","text-align":"center"} }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _hoisted_10,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    name: "tranche_id",
                    placeholder: "Select Tranche",
                    modelValue: _ctx.batch.tranche_id,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.batch.tranche_id) = $event)),
                    filterable: "",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tranches_info, (tranche) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: tranche.id,
                          label: tranche.label,
                          value: tranche.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(tranche.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _hoisted_13,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    placeholder: "Select Training Partner",
                    name: "entity_id",
                    modelValue: _ctx.batch.entity_id,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.batch.entity_id) = $event)),
                    filterable: "",
                    style: {"width":"100%"},
                    onChange: _ctx.getTrainingInstitute
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityInfos, (info) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: info.id,
                          label: 
                      '[' + info.entity_short_name + '] - ' + info.entity_name
                    ,
                          value: info.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString("[" + info.entity_short_name + "] - " + info.entity_name), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange"])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    placeholder: "Select Institute",
                    modelValue: _ctx.batch.institute_id,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.batch.institute_id) = $event)),
                    name: "institute_id",
                    filterable: "",
                    style: {"width":"100%"},
                    onChange: _ctx.courseInfo
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.instituteList, (info) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: info.id,
                          label: info.institute_name,
                          value: info.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(info.institute_name), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange"])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    placeholder: "Select Course",
                    modelValue: _ctx.batch.course_id,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.batch.course_id) = $event)),
                    name: "course_id",
                    filterable: "",
                    style: {"width":"100%"},
                    onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.batchInfo()))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courseList, (info) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: info.id,
                          label: info.course_name,
                          value: info.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(info.course_name), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _hoisted_20,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    placeholder: "Select Batch",
                    modelValue: _ctx.batch.batch_id,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.batch.batch_id) = $event)),
                    name: "batch_id",
                    filterable: "",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.batchList, (info) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: info.id,
                          label: info.batch_sequence_number,
                          value: info.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(info.batch_sequence_number), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("button", {
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.getDetails())),
                    type: "button",
                    class: "btn btn-success p-3",
                    style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                  }, [
                    _createTextVNode(" Search "),
                    _hoisted_22
                  ])
                ])
              ]),
              (_ctx.showJobData)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _hoisted_24,
                    _createElementVNode("div", _hoisted_25, [
                      _hoisted_26,
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-success btn-lg btn-icon fs-7 p-4",
                          title: "Download Xlse",
                          "data-v-54b12dc8": "",
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.exportTrainee()))
                        }, _hoisted_29),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-danger btn-lg btn-icon fs-7 ml-3 p-4",
                          title: "Download PDF",
                          "data-v-54b12dc8": "",
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.downloadPdf()))
                        }, _hoisted_31),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-dark btn-lg btn-icon fs-7 ml-3 p-4",
                          title: "Print",
                          "data-v-54b12dc8": "",
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.printPdf()))
                        }, _hoisted_33)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("table", _hoisted_35, [
                        _hoisted_36,
                        _hoisted_37,
                        _hoisted_38,
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.details, (info, index) => {
                            return (_openBlock(), _createElementBlock("tr", { key: index }, [
                              _createElementVNode("td", _hoisted_39, _toDisplayString(index + 1), 1),
                              _createElementVNode("td", _hoisted_40, _toDisplayString(info.registration_number), 1),
                              _createElementVNode("td", _hoisted_41, _toDisplayString(info.name), 1),
                              _createElementVNode("td", _hoisted_42, _toDisplayString(info.mobile), 1),
                              _createElementVNode("td", _hoisted_43, _toDisplayString(info?.before_assessment?.designation), 1),
                              _createElementVNode("td", _hoisted_44, _toDisplayString(info?.before_assessment?.joining_date ?
                            _ctx.moment(info?.before_assessment?.joining_date).format("DD-MM-YYYY") : ""), 1),
                              _createElementVNode("td", _hoisted_45, _toDisplayString(info?.before_assessment?.release_date ?
                            _ctx.moment(info?.before_assessment?.release_date).format("DD-MM-YYYY") : "-"), 1),
                              _createElementVNode("td", _hoisted_46, _toDisplayString(info?.before_assessment?.salary), 1),
                              _createElementVNode("td", _hoisted_47, _toDisplayString(info?.before_assessment?.organization_name), 1),
                              _createElementVNode("td", _hoisted_48, _toDisplayString(info?.three_months_after?.designation), 1),
                              _createElementVNode("td", _hoisted_49, _toDisplayString(info?.three_months_after?.joining_date ?
                            _ctx.moment(info?.three_months_after?.joining_date).format("DD-MM-YYYY") : ""), 1),
                              _createElementVNode("td", _hoisted_50, _toDisplayString(info?.three_months_after?.release_date ?
                            _ctx.moment(info?.three_months_after?.release_date).format("DD-MM-YYYY") : "-"), 1),
                              _createElementVNode("td", _hoisted_51, _toDisplayString(info?.three_months_after?.salary), 1),
                              _createElementVNode("td", _hoisted_52, _toDisplayString(info?.three_months_after?.organization_name), 1),
                              _createElementVNode("td", _hoisted_53, _toDisplayString(info?.six_months_after?.designation), 1),
                              _createElementVNode("td", _hoisted_54, _toDisplayString(info?.six_months_after?.joining_date ?
                            _ctx.moment(info?.six_months_after?.joining_date).format("DD-MM-YYYY") : ""), 1),
                              _createElementVNode("td", _hoisted_55, _toDisplayString(info?.six_months_after?.release_date ?
                            _ctx.moment(info?.six_months_after?.release_date).format("DD-MM-YYYY") : "-"), 1),
                              _createElementVNode("td", _hoisted_56, _toDisplayString(info?.six_months_after?.salary), 1),
                              _createElementVNode("td", _hoisted_57, _toDisplayString(info?.six_months_after?.organization_name), 1),
                              _hoisted_58
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])), [
        [_directive_loading, _ctx.loading]
      ])
    ])
  ]))
}